var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single"},[_c('b-container',[_c('b-row',[_c('b-col',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.wpInfo[0].content.rendered)}})])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }